let supportLS = true;

try {
    // ie开启了保护模式localStorage会报错
    const temp = window.localStorage;
    if (!temp) {
        supportLS = false;
    }
} catch (e) {
    supportLS = false;
}

const localStoragePerfect = {
    setItem(name: string, value: string) {
        if (supportLS) {
            window.localStorage.setItem(name, value);
        } else {
            const d = new Date();
            d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
            const expires = `expires=${d.toUTCString()}`;
            document.cookie = `${name}=${value}; ${expires}; path=/`;
        }
    },
    getItem(name: string) {
        let value;
        if (supportLS) {
            value = window.localStorage.getItem(name);
        } else {
            value = this.getCookie(name);
        }
        return value;
    },
    getCookie(name: string) {
        if (document.cookie.length > 0) {
            let start = document.cookie.indexOf(`${name}=`);
            if (start !== -1) {
                start = start + name.length + 1;
                let end = document.cookie.indexOf(';', start);
                if (end === -1) {
                    end = document.cookie.length;
                }
                return unescape(document.cookie.substring(start, end));
            }
        }
        return '';
    }
};

export default localStoragePerfect;
